import { render, staticRenderFns } from "./PCBConverterMagnetic.vue?vue&type=template&id=28be6d42&scoped=true&"
import script from "./PCBConverterMagnetic.vue?vue&type=script&lang=js&"
export * from "./PCBConverterMagnetic.vue?vue&type=script&lang=js&"
import style0 from "./PCBConverterMagnetic.vue?vue&type=style&index=0&id=28be6d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be6d42",
  null
  
)

export default component.exports